import { Typography } from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import { uuid4 as uuid } from "@sentry/utils";
import clsx from "clsx";

import { useStyles } from "@/common/components/MapLandingPage/RightUnitDrawer/CameraNavigationStyles";
import * as FullStory from "@/utilities/hooks/fullstory";
import { CameraInformation } from "@/utilities/types/liveunit";

import CameraPreview from "./CameraPreview";


export interface CameraNavigationProps {
    cameraList: CameraInformation[] | null;
    defaultCameraId: number | null;
}

const CameraNavigation: React.FC<CameraNavigationProps> = ({ cameraList, defaultCameraId }) => {
    const classes = useStyles();

    return (
        <>
            {cameraList ? (
                <div>
                    <Typography className={classes.head} variant="h4">
                        Cameras
                    </Typography>
                    <div className={classes.cameras}>
                        {cameraList.length > 0 ? (
                            <>
                                {cameraList.map((camera) => (
                                    <CameraPreview
                                        key={uuid()}
                                        className={clsx(FullStory.names.classes.searchDrawer.anyCamera, camera.id && (camera.id === defaultCameraId) ? FullStory.names.classes.searchDrawer.defaultCamera : "")}
                                        cameraId={camera.id}
                                        cameraName={camera.name}
                                        presetId={camera.thumbnailPreset}
                                    />
                                ))}
                            </>
                        ) : (
                            <span>No cameras to preview for this live unit.</span>
                        )}
                    </div>
                </div>
            ) : (
                <Alert severity="warning">Unable to fetch cameras for this live unit</Alert>
            )}
        </>
    );
};

export default CameraNavigation;
